import React from 'react';
import { PaginationList } from '../styles';
import { NextButton, PreviousButton } from '../shared';

var MinimalPagination = function MinimalPagination(_ref) {
  var pageUrls = _ref.pageUrls,
      currentPage = _ref.currentPage,
      onChangePage = _ref.onChangePage,
      className = _ref.className,
      dataTest = _ref['data-test'];
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": "pagination",
    className: className,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(PaginationList, {
    "data-test": "pagination"
  }, /*#__PURE__*/React.createElement(PreviousButton, {
    currentPage: currentPage,
    onChangePage: onChangePage,
    pageUrls: pageUrls
  }), /*#__PURE__*/React.createElement(NextButton, {
    currentPage: currentPage,
    onChangePage: onChangePage,
    pageUrls: pageUrls
  })));
};

MinimalPagination.displayName = 'MinimalPagination';
export default MinimalPagination;